import React, { useCallback, useMemo, useState } from 'react';
import Dropdown from './Dropdown';
import Loading from './Loading';
import { locales } from '../config';
import UserInfoActions from '../actions/UserInfoActions';
import store from '../stores/redux';
import typeOf from '../helpers/typeOf';

export default function Locale() {
    const currentLocale = store.getState().user?.locale;
    const [loadingKey, setLoadingKey] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [locale, setLocale] = useState(currentLocale);

    const active = useMemo(
        () => locales.find((l) => l.key === locale) || locales[0],
        [locale]
    );

    const onUpdate = useCallback((key) => {
        if (key === locale) return;
        setIsLoading(true);
        setLoadingKey(key);
        UserInfoActions.edit({ locale: key }).then((res) => {
            if (typeOf.isNumeric(res) && res === 1) {
                // backend persisted – reload to rehydrate translations
                window.location.reload();
            } else {
                setIsLoading(false);
                setLocale(key);
            }
        });
    }, [locale]);

    return (
        <div className="locale">
            <Dropdown
                mainClass={{ dropdown: true }}
                headerClass={{ 'dropdown-toggle': true, menu: true }}
                isCloseDocument={true}
                header={
                    <span className="locale__name">
            <i className="flag-icon">
              <img src={active.image} alt={active.name} />
            </i>
                        {active.name}
          </span>
                }
            >
                <ul className="dropdown-menu">
                    {locales.map((item) => {
                        const isActive = item.key === locale;
                        const btnClass = [
                            'btn-empty',
                            isActive ? 'active' : '',
                            isActive ? 'disabled' : '',
                        ]
                            .filter(Boolean)
                            .join(' ');
                        return (
                            <li key={item.key}>
                                <button
                                    className={btnClass}
                                    onClick={!isActive ? () => onUpdate(item.key) : undefined}
                                    disabled={isActive}
                                >
                                    <i className="flag-icon">
                                        <img src={item.image} alt={item.name} />
                                    </i>
                                    {item.name}
                                </button>
                                {isLoading && loadingKey === item.key ? (
                                    <div className="locale__loading">
                                        <Loading inherit />
                                    </div>
                                ) : null}
                            </li>
                        );
                    })}
                </ul>
            </Dropdown>
        </div>
    );
}
